import {
  GET_ALL_MEDRA_DISEASE,
  GET_MEDDRA_DISEASE,
  GET_MEDDRA_DISEASE1,
  GET_MEDDRA_DISEASE2,
  GET_ALL_MEDDRA_VERSIONS,
  UPLOAD_MEDDRA_DETAILS,
  PREVIEW_MEDDRA_CHANGES,
  APPLY_MEDDRA_CHANGES,
  GET_DETAILED_CHANGES,
  GET_AFFECTED_CASES_REPORT,
} from '../types'

const INITIAL_STATE = {
  allmeddraDisease: [],
  meddraDisease: [],
  meddraDisease1: [],
  meddraDisease2: [],
  getAllMedDraVersions: [],
  getMeddraVersions: [],
  uploadMeddraDetails: [],
  previewChanges: null,
  applyChanges: null,
  detailedChanges: null,
  affectedCasesReport: null,
}

const meddraReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_MEDRA_DISEASE:
      return {
        ...state,
        allmeddraDisease: payload.data,
      }

    case GET_MEDDRA_DISEASE:
      return {
        ...state,
        meddraDisease: payload,
      }

    case GET_MEDDRA_DISEASE1:
      return {
        ...state,
        meddraDisease1: payload,
      }
    case GET_MEDDRA_DISEASE2:
      return {
        ...state,
        meddraDisease2: payload,
      }
    case GET_ALL_MEDDRA_VERSIONS:
      return {
        ...state,
        getAllMedDraVersions: payload.data,
      }
    // case GET_ALL_MIGRATED_MEDDARA_VERSIONS:
    //   return {
    //     ...state,
    //     getMeddraVersions: payload.data,
    //   }
    case UPLOAD_MEDDRA_DETAILS:
      return {
        ...state,
        uploadMeddraDetails:payload.data
      }
    case PREVIEW_MEDDRA_CHANGES:
      return {
        ...state,
        previewChanges: payload,
      }
    case APPLY_MEDDRA_CHANGES:
      return {
        ...state,
        applyChanges: payload,
      }
    case GET_DETAILED_CHANGES:
      return {
        ...state,
        detailedChanges: payload,
      }
    case GET_AFFECTED_CASES_REPORT:
      return {
        ...state,
        affectedCasesReport: payload,
      }
    default:
      return state
  }
}

export default meddraReducer
